import { connect } from 'react-redux'
import Modal from './Modal'
import { closeModal } from '../../store/appReducer'

const mapActionCreators = {
  closeModal,
}

const mapStateToProps = state => ({
  modalIsOpen: state.app.modalIsOpen,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(Modal)



// WEBPACK FOOTER //
// ./src/legacy/containers/Modal/container.js